<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Area-->
<div class="MainContent">
	<!--Side Bar-->
	<div class="MainSidebar">
		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: PageIndex == 0,
				FinishedButton: PageIndex != 0 && UserDetailsStatus == 1,
				ErrorButton: PageIndex != 0 && UserDetailsStatus == 2
			}"
			(click)="onNavClick(0)"
			[disabled]="IsLoading() == true"
		>
			User Details
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: PageIndex == 1,
				FinishedButton: PageIndex != 1 && SchoolsStatus == 1,
				ErrorButton: PageIndex != 1 && SchoolsStatus == 2
			}"
			(click)="onNavClick(1)"
			[disabled]="IsLoading() == true"
		>
			Schools
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: PageIndex == 2,
				FinishedButton: PageIndex != 2 && RolesStatus == 1,
				ErrorButton: PageIndex != 2 && RolesStatus == 2
			}"
			(click)="onNavClick(2)"
			[disabled]="IsLoading() == true"
		>
			Roles
		</button>

		<button
			*ngIf="ShowUserGroups() == true"
			[ngClass]="{
				navButton: true,
				ActiveButton: PageIndex == 3,
				FinishedButton: PageIndex != 3 && UserGroupsStatus == 1,
				ErrorButton: PageIndex != 3 && UserGroupsStatus == 2
			}"
			(click)="onNavClick(3)"
			[disabled]="IsLoading() == true"
		>
			User Groups
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: PageIndex == 4,
				FinishedButton: PageIndex != 4 && EmailStatus == 1,
				ErrorButton: PageIndex != 4 && EmailStatus == 2
			}"
			(click)="onNavClick(4)"
			[disabled]="IsLoading() == true"
		>
			Email/Messaging
		</button>
	</div>

	<!--Content-->
	<div class="MainMenu">
		<div class="ComponentOverflow">
			<caass-user-modify-details
				[ngClass]="{
					ShowSection: PageIndex == 0,
					HideSection: PageIndex != 0
				}"
				[EditMode]="EditMode"
				[UserID]="UserID"
				[SchoolID]="SchoolID"
				[Processing]="Processing || SchoolRoleLoading || PreferenceLoading"
			>
			</caass-user-modify-details>

			<caass-user-modify-schools
				[ngClass]="{
					ShowSection: PageIndex == 1,
					HideSection: PageIndex != 1
				}"
				[EditMode]="EditMode"
				[UserID]="UserID"
				(lstSchoolChanged)="onlstSchoolChanged($event)"
				[Processing]="Processing || SchoolRoleLoading || PreferenceLoading"
			>
			</caass-user-modify-schools>

			<caass-user-modify-roles
				[ngClass]="{
					ShowSection: PageIndex == 2,
					HideSection: PageIndex != 2
				}"
				[UserLevelID]="UserLevelID"
				[lstSchool]="lstSchool"
				[Processing]="Processing || SchoolRoleLoading || PreferenceLoading"
			>
			</caass-user-modify-roles>

			<caass-user-modify-user-groups
				[ngClass]="{
					ShowSection: PageIndex == 3,
					HideSection: PageIndex != 3
				}"
				[EditMode]="EditMode"
				[UserID]="UserID"
				[UserLevelID]="UserLevelID"
				[Processing]="Processing || SchoolRoleLoading || PreferenceLoading"
			>
			</caass-user-modify-user-groups>

			<caass-user-modify-email
				[ngClass]="{
					ShowSection: PageIndex == 4,
					HideSection: PageIndex != 4
				}"
				[EditMode]="EditMode"
				[UserID]="UserID"
				[Username]="Username"
				[PersonName]="PersonName"
				[lstSchool]="lstSchool"
				[UserAdminManualEmail]="UserAdminManualEmail"
				[Processing]="Processing || SchoolRoleLoading || PreferenceLoading"
			>
			</caass-user-modify-email>
		</div>

		<div class="NextBackButtons">
			<button [disabled]="IsLoading() == true" *ngIf="PageIndex > 0" class="btn btn-primary" (click)="onBack()">&lt; Back</button>
			<button [disabled]="IsLoading() == true" *ngIf="PageIndex < 4" class="btn btn-primary" (click)="onNext()">Next &gt;</button>
		</div>
	</div>
</div>

<!--Buttons-->
<div id="MainButtons" class="Buttons">
	<button [disabled]="IsLoading() == true" *ngIf="EditMode == false" class="btn btn-success" (click)="onAdd()">Finish</button>
	<button [disabled]="IsLoading() == true" *ngIf="EditMode == true" class="btn btn-success" (click)="onUpdate()">Update</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
